import { Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react";
import { searchContacts } from "../../../store/slices/userRequests";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import ImageProfileCircle from "../../../components/ImageProfileCircle";
import TablePaginationBar from "../../../components/MyTable/tablePaginationBar";
import MySelectCompany from "../../../components/MySelectCompany";
import { getStaffPositions } from "../../../api/signalApi";


const Directory = () => {

    const dispatch = useDispatch<AppDispatch>();
    const theme = useTheme();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {requestContacts: {contacts, totalItems}, staffPositions} = useSelector((state: RootState) => state.userRequests);
    // const [selectedCompany, setSelectedCompany] = useState<string>("todas");
    const [itemsPerPage, setItemsPerPage] = useState<number>(10)
    const [pageNumber, setPageNumber] = useState<number>(1)
    const [description, setDescription] = useState<string>("")
    const [timeoutId, setTimeoutId] = useState<any>(null);
    const [rucSelected, setRucSelected] = useState<string>("")
    const [staffPositionSelected, setStaffPositionSelected] = useState<string>("*")


    useEffect(() => {
        if (!companyselected || !connectionId) return;
        getStaffPositions(rucSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId, rucSelected])

    useEffect(() => {
        if (!companyselected || !connectionId) return;
        dispatch(searchContacts({
            ruc: rucSelected === "all" ? "" : rucSelected,
            staffPosition: staffPositionSelected === "*" ? "" : staffPositionSelected,
            pageQuantity: itemsPerPage, 
            pageNumber: pageNumber, 
            description: description, 
            onlyActives: 1,
        }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId, itemsPerPage, pageNumber, description, rucSelected, staffPositionSelected])

    const handleChange = (event: any) => {
        if(timeoutId) {
            console.log("#### clearing ####")
            clearTimeout(timeoutId);
        }
        const newTimeoutId = setTimeout(() => {
            console.log('Enviar descripción al API:', event.target.value);
            setPageNumber(1);
            setDescription(event.target.value);
        }, 600);
        setTimeoutId(newTimeoutId);
    };

    return  (
        <Grid container direction="row" item width="100%" minHeight="60%" marginTop="1rem">
            
        <Grid container item rowSpacing="1rem" justifyContent="space-between">
            
            <MySelectCompany
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={"all"}
                setRucSelected={(value) => {
                    setPageNumber(1);
                    setRucSelected(value);
                }} 
                rucSelected={rucSelected}
            />
            <Grid item>
                <FormControl style={{minWidth: "15rem"}}>
                    <InputLabel id="select-option-label">Tipo de Nómina</InputLabel>
                    <Select
                        labelId="select-option-label"
                        id="select-option"
                        label={"Tipo de Nómina"}
                        onChange={(event: { target: { value: string } }) => {
                            const value = event.target.value;
                            setPageNumber(1);
                            setStaffPositionSelected(value);
                        }}
                        value={staffPositionSelected}
                        style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                    >
                        <MenuItem 
                            value={"*"}
                        >
                            Todas
                        </MenuItem>
                        {staffPositions?.map((item, i) => (
                            <MenuItem
                                key={i} 
                                value={item.NroEsquemaPlanilla}
                            >
                                {item.Descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} container alignItems="flex-end" justifyContent="flex-end">
                <Grid item sx={{ width: { xs: "100%", sm: "12rem" } }}>
                    <input
                        placeholder="Buscar..."
                        style={{
                        width: "100%",
                        height: "2.5rem",
                        borderRadius: ".25rem",
                        border: `1px solid ${theme.s10palette.S10Greygrey50}`,
                        paddingLeft: "0.5rem"
                        }}
                        onChange={handleChange}
                        // value={description} 
                    />
                </Grid>
            </Grid>
        </Grid>
            
            <Grid item width="100%" margin={0} padding={0}>
                <TablePaginationBar
                    totalItems={totalItems}
                    style={{marginTop: 0}}
                    page={pageNumber}
                    itemsPerPage={itemsPerPage}
                    setPage={setPageNumber}
                    onChangePageQuantity={(itemsPerPage) => {
                        setPageNumber(1);
                        setItemsPerPage(itemsPerPage)
                    }}
                    setStartItemIndex={() => {}}
                    setFinishtemIndex={() => {}}
                />
            </Grid>

            <Grid container item width="100%" minHeight="60%">
                {contacts?.map((contact, i) => (
                    <Grid key={i} item xs={12} sm={6} md={4} lg={3} padding=".5rem">
                        <Card sx={{ display: 'flex', }} style={{minHeight: "8rem", padding: 0}}>
                            <Grid style={{padding: "2rem 0 1rem 1rem"}}>
                                <ImageProfileCircle
                                    width="40px"
                                    height="40px"
                                    ruc={contact.RUCEmpresa}
                                    userName={contact.Descripcion}
                                    userId={contact.CodIdentificador}
                                />
                            </Grid>
                            <CardContent sx={{ flex: 1 }}>
                                <Typography 
                                    gutterBottom 
                                    variant="h6" 
                                    component="div"
                                    sx={{
                                        // height: '2.6em',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        overflow: 'hidden',
                                        color: theme.s10palette.S10Blueblue700
                                    }}
                                    fontSize=".8em"
                                >
                                    {contact.Descripcion}
                                </Typography>
                                <Typography
                                    variant="h6"
                                    color="text.secondary"
                                    marginBottom=".2rem"
                                    fontSize=".7em"
                                >
                                    {contact.DescripcionEmpresa || "-"}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    marginBottom=".5rem"
                                    // height="1rem"
                                >
                                    {contact.Cargo || "-"}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    // style={{lineHeight: "1.5em"}}
                                >
                                    {contact.EMail}
                                </Typography>
                                <Typography variant="body2">
                                    {contact.TelefonoMovil}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

export default Directory